module.exports = __webpack_public_path__ + "img/remixicon.f3686cbd.svg";